import React from 'react';
import { Text, View, StyleSheet } from 'react-native';

import { COLOR, FONT, FONT_SIZE, THEME } from '../../constants/styles';

export function SimpleHeader(props) {
  return (
    <View style={[styles.simpleHeader, props.containerStyle]}>
      <Text style={styles.simpleHeaderText}>{props.label}:</Text>
      {!!props.required && <Text style={styles.requiredAsterisk}>*</Text>}
    </View>
  );
}

const styles = StyleSheet.create({
  simpleHeader: {
    flexDirection: 'row',
    height: 60,
    alignItems: 'center',
    backgroundColor: COLOR.accent,
    borderColor: '#e4e4e4',
    paddingHorizontal: 25,
    borderBottomWidth: 1,
    borderTopWidth: 1,
  },
  simpleHeaderText: {
    ...FONT.medium,
    fontSize: FONT_SIZE.small,
    color: COLOR.text,
  },
  requiredAsterisk: {
    color: COLOR.emphasis,
    paddingLeft: 2,
    fontSize: 18,
  },
});
